
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
    data() {
        return {
        }
    },
    methods: {

        ////////////////////////////////////
        //モーダル開閉
        ////////////////////////////////////
        modalShowClick: function (e) {
            var target = $(e.target);
            var targetModalSelector = target.attr('data-modal');
            if (!targetModalSelector) {
                targetModalSelector = target.parents('[data-modal]').attr('data-modal');
            }
            $('.modal_container.' + targetModalSelector).addClass('_open');
            $('.modal_bg').addClass('_on');
        },
        modalShowForTargetClass: function (targetModalSelector) {
            $('.modal_container.' + targetModalSelector).addClass('_open');
            $('.modal_bg.' + targetModalSelector).addClass('_on');
        },
        modalCloseClick: function () {
            $('.modal_container').removeClass('_open');
            $('.modal_bg').removeClass('_on');
        },

        window: onload = function () {
            ////////////////////////////////////
            //ページが読み込まれたら ScrollTrigger.js の トリガー位置を再計算する
            ////////////////////////////////////
            ScrollTrigger.refresh(true);

            ////////////////////////////////////
            //100vhをmobileでもステータスバー等の影響を受けないようにする
            ////////////////////////////////////
            const setFillHeight = () => {
                const vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            }
            // 画面のサイズ変動があった時に高さを再計算する
            window.addEventListener('resize', setFillHeight);
            // 初期化
            setFillHeight();

        },

        //.js-scroll-target がビューポートの75％に入ったら ._on を付与。15%で外す。
        jsScrollTargets: function () {
            var jsScrollTargets = gsap.utils.toArray('.js-scroll-target');
            jsScrollTargets.forEach((jsScrollTarget) => {
                gsap.to(jsScrollTarget, {
                    scrollTrigger: {
                        trigger: jsScrollTarget,
                        start: 'top 75%', //発火位置を変更したい場合はここを調整
                        end: 'bottom 15%', //発火位置を変更したい場合はここを調整
                        toggleClass: "_on"
                    }
                });
            })
        },

        //CursorFollower
        cursorFollower: function () {
            gsap.set('.md_cursor-follower', { xPercent: -50, yPercent: -50 });
            gsap.set('.md_cursor', { xPercent: -50, yPercent: -50 });

            var follow = document.querySelector('.md_cursor-follower');
            var cur = document.querySelector('.md_cursor');

            window.addEventListener('mousemove', e => {
                gsap.to(cur, 0, { x: e.clientX, y: e.clientY });
                gsap.to(follow, 1.5, { x: e.clientX, y: e.clientY });
            });

            $("a, label, .md_icon-btn, button, input, select, textarea, .js-follow-active").on("mouseenter", function () {
                $('.md_cursor').addClass('active');
                $('.md_cursor-follower').addClass('active');
            });
            $("a, label, .md_icon-btn, button, input,  select,textarea, .js-follow-active").on("mouseleave", function () {
                $('.md_cursor').removeClass('active');
                $('.md_cursor-follower').removeClass('active');
            });

        },

    },//methods

    mounted() {
        // 一度しか走らないように制御
        if (this.$store.state.const.utility_again) {
            return;
        }
        this.$store.state.const.utility_again = true;

        ////////////////////////////////////
        ////ToggleOnClass
        ////////////////////////////////////
        $(".js-toggle-on").click(function () {
            $(this).toggleClass('_on');
        });

        ////////////////////////////////////
        ////スワイパーをクリックするとアンカーリンクで定位位置に戻す
        ////////////////////////////////////
        $(function () {
            $(document).on('click', '.js-swiper-next', '.js-swiper-back', function () {
                var speed = 500;
                var href = $(this).attr("href");
                var target = $(href == "#" || href == "" || href == undefined ? 'html' : href);
                var position = target.offset().top;
                $("html, body").animate({ scrollTop: position }, speed, "swing");
                return false;
            });
        });

        ////////////////////////////////////
        //トースト出現
        ////////////////////////////////////
        // $('.js-toast-show').click(function (e) {
        //     console.log('TEST');
        //     $('.md_toast').addClass('_show');
        //     setTimeout(() => {
        //         $('.md_toast').removeClass('_show');
        //     }, 8000);
        // });

    },
};
